
export default class MenuLayoutController {

	constructor (Session, User, Sso, $state, $filter) {
		// dependencies
		this.translate = $filter('translate');
		this.User = User;
		this.$state = $state;
		this.Session = Session;
		this.Sso = Sso;
		this.brand = this.Session.get('brandObject');
		this.active = !User.isWorker();
		// data
		this.logo = require('../../mangooid-logo.png');
		this.menu = [
			{ 
				title: this.translate('DIGITAL_RECEIPT'),
				icon: 'icon-file-text',
				hasChildren: true,
				super: false,
				action: this.goToState('summaryPage'),
				prefix: 'summary',
				children: [
					{submenuTitle :this.translate('INDICATORS'), 
					 icon: 'icon-stats-line', action: this.goToState('summaryPage'), prefix : 'summaryPage'},
					{submenuTitle :this.translate('DETAILS'), 
					 icon: 'icon-search', action: this.goToState('receiptsDetailsPage'), prefix : 'receiptsDetailsPage'},
					this.brand.hasButtonsLogs ? {submenuTitle :this.translate('RANKING'), 
					 icon: 'icon-list-numbered', action: this.goToState('summaryRankingPage'), prefix : 'summaryRankingPage'} : undefined
				].filter(elem => elem !== undefined)
			},
			{ 
				title: this.translate('REVIEWS'),
				icon: 'icon-bubble',
				super: false,
				hasChildren: true,
				disabled: !this.brand.showNpsPage && !this.brand.showRatingPage,
				children: [
					{submenuTitle :this.translate('INDICATORS'), 
					 icon: 'icon-stats-pie', action: this.goToState('reviewsIndicatorsPage'), prefix : 'reviewsIndicators'},
					{submenuTitle :this.translate('DETAIL'), 
					 icon: 'icon-search', action: this.goToState('reviewsPage'), prefix : 'reviewsPage'}, 
					{submenuTitle : this.translate('RANKING'),
					 icon: 'icon-list-numbered', action : this.goToState('reviewsRankingPage'), prefix : 'reviewsRanking'},
					{submenuTitle: this.translate('SURVEYS'),
					 icon: 'icon-clipboard', action: this.goToState('surveysPage'), prefix: 'survey'},
				],	
				action: this.goToState('reviewsIndicatorsPage'), 
				prefix: 'reviews'
			},
			{ title: this.translate('NOTES'),     icon: 'icon-star-empty',    super: false, disabled: !this.brand.allowProductRatingEmails, action: this.goToState('productsRatingPage'),             prefix: 'productsRating' },
			{
				title: this.translate('SETTINGS'),
				icon: 'icon-wrench', super: true,
				action: this.goToState('preferencesPage'),
				prefix: 'preferences',
				hasChildren: true,
				children: [
					{ submenuTitle: this.translate('PREFERENCES'), icon: 'icon-preferences', super: true,  action: this.goToState('preferencesPage'),                prefix: 'preferences'},
					{ submenuTitle: this.translate('MARKETERS'),   icon: 'icon-user',        super: true,  action: this.goToState('marketersPage'),                  prefix: 'marketer' },
					{ submenuTitle: this.translate('STORES'),      icon: 'icon-home',        super: true,  action: this.goToState('storesPage'),                     prefix: 'store' },
					{ submenuTitle: this.translate('TEMPLATES'),   icon: 'icon-file-text2',  super: true,  action: this.goToState('emailTemplatesPage'),             prefix: 'emailTemplate', charlie: true }
				]
			},
			// { title: this.translate('TUTORIAL'),    icon: 'icon-books',       super: false, action: this.goToState('tutorialPage'),                   prefix: 'tutorial' },
			{ title: this.translate('LOGOUT'),      icon: 'icon-exit',        super: false, action: this.logout.bind(this) },
		];

	}

	logout () {
		this.User.logout()
			.then(_ => {
				const group = this.Sso.getGroup();
				if (group) {
					this.$state.go('ssoLoginPage', { group: group });
				} else {
					this.$state.go('loginPage');
				}
			});
	}

	isLinkAvailable (link) {
		var user = this.User.get();
		return (!link.super   || user && user.super)
			&& (!link.charlie || user && user.email === 'charlie@mangooid.com');
	}

	getMenu () {
		return this.menu.filter(link => this.isLinkAvailable(link));
	}

	goToState (state, params) {
		return _ => state && this.$state.go(state, params);
	}

	isActive (link) {
		return link.prefix && ((this.$state.current.name.indexOf(link.prefix) === 0) || (link.hasChildren && link.children.filter(child => this.$state.current.name.indexOf(child.prefix) === 0).length > 0));
	}

	isDisabled (link) {
		return !!link.disabled;
	}

	getChildren() {	
		const activeRootMenu = this.menu.filter(link => {
			return this.isActive(link) && link.children;
		})[0];
		return activeRootMenu
			&& activeRootMenu.children.filter(link => this.isLinkAvailable(link))
			|| [];
    }

}

MenuLayoutController.$inject = ['Session', 'User', 'Sso', '$state', '$filter'];



// WEBPACK FOOTER //
// ./src/directive/menu-layout/menu-layout.controller.js